<template>
  <div>
    <h1 class="logintitle">
      <img src="@/assets/starmap/images/starmap.png">
      <h1>星图starmap</h1>
    </h1>
    <div class="loginbox">
      <form method="post" @submit.stop.prevent="submit">
        <ul>
          <li class="input-icon">
            <input v-model.trim="username" @input="clearErrMsg" name="username" autocomplete="off" type="text" placeholder="请输入用户名">
            <span v-show="invalidUsername">{{ errorMsg }}</span>
          </li>
          <li class="input-icon icon-pwd">
            <input v-model.trim="password" @input="clearErrMsg" name="password" autocomplete="off" type="password" placeholder="请输入密码">
            <span v-show="invalidPassword">您输入的密码有误</span>
          </li>
          <li>
            <button class="login-btn" type="submit">登录</button>
          </li>
          <li>
            <a class="clear-link" @click="clearStorage">清空本地缓存</a>
          </li>
        </ul>
      </form>
    </div>
    <div class="loginbm">
      <h4>星图考培信息系统</h4>
      <p>Star Map exam&training Information System</p>
      <p><a href="https://starmap.jiemo.net">starmap.jiemo.net</a> Copyright © {{ year }} Star Map. All Rights Reserved</p>
    </div>
  </div>
</template>
<script>
import { _post } from '@/utils/http';
import lockr from 'lockr';

export default {
  name: 'Login',
  data() {
    return {
      invalidUsername: false,
      invalidPassword: false,
      username: '',
      password: '',
      errorMsg: '',
    };
  },
  computed: {
    year() {
      return (new Date()).getFullYear();
    }
  },
  methods: {
    clearStorage() {
      this.$message.success(`已经清理本地缓存${localStorage.length}条`);
      lockr.flush();
      localStorage.clear();
    },
    clearErrMsg() {
      this.invalidUsername = false;
    },
    submit() {
      if (!this.username) {
        this.invalidUsername = true;
        return false;
      }
      _post({
        url: '/index/login/index',
        data: {
          username: this.username,
          password: this.password
        }
      }).then((res) => {
        if (res.code > 0) {
          this.errorMsg = res.msg;
          this.invalidUsername = true;
          return false;
        }
        lockr.set('jwt', res.data);
        window.location.href = '/';
      });
      return false;
    }
  },
  beforeCreate() {
    lockr.set('jwt', null);
  }
};
</script>

<style>
body {
  height: 100%;
  background-image: url('../../assets/starmap/images/bg.jpg');
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  overflow: hidden;
}
#app {
  padding-top: 130px;
}
h1 {
  padding-top: 10px!important;
  font-size: 18px;
}
input {
  border: none;
  background: none;
  width: 300px;
  height: 55px;
  border: none;
  line-height: 74px;
  font-size: 18px;
  outline: none;
  border-bottom: 1px solid #838BA9;
  color: #fff;
  font-family: "微软雅黑", Microsoft Yahei;
}
li.input-icon {
  background: url('../../assets/starmap/images/icon-name.png') no-repeat left center;
}
li.icon-pwd {
  background-image: url('../../assets/starmap/images/icon-pass.png')
}
.login-btn {
  background-color: #43D6B3;
  cursor: pointer;
  color: #FFF;
  height: 50px;
  width: 260px;
  border: none;
  border-radius: 25px;
  margin-top: 40px;
}
.clear-link {
  display: block;
  padding: 10px;
  color:#ffffffaa;
  cursor: pointer;
  font-size:13px;
}
.logintitle {
  text-align: center;
  color: #fff;
  font-weight: bold;
  font-size: 36px;
  margin-bottom: 40px;
  animation: wobble-vertical 10s linear infinite;
}
.logintitle2 {
  text-align: center;
  color: #fff;
  font-size: 28px;
  font-weight: 200;
  padding: 70px 0;
}
.loginbox {
  width: auto;
  height: 336px;
  margin: auto;
  text-align: center;
  padding-bottom: 40px;
  animation: loginmove 1s ease-out 1;
}

.loginbox ul li {
  position: relative;
  display: block;
  width: 384px;
  margin: auto;
  padding: 5px 0;
}
.loginbox ul li span {
  position: absolute;
  right: -200px;
  bottom: 0;
  display: block;
  width: 211px;
  height: 52px;
  text-align: center;
  line-height: 52px;
  background-color: #fcd71d;
  font-size: 18px;
  color: #383838;
}
.loginbox ul li span:before {
  display: block;
  content: "";
  position: absolute;
  left: -10px;
  top: 50%;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #fcd71d;
  border-left: none;
  margin-top: -10px;
}

.loginbm {
  line-height: 23px;
  text-align: center;
  width: 100%;
  color: #fff;
  animation: loginmove 2s ease-out 1;
}
.loginbm h4 {
  color: #fff;
  font-size: 14px;
  font-weight: 200;
}
.loginbm p {
  color: #fff;
  font-size: 12px;
  padding: 0;
  margin: 0;
  opacity: 0.8;
}

.loginbm a {
  font-weight: bold;
  color: #fff;
}

.loginbm a:hover {
  color: #fff;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus textarea:-webkit-autofill,
textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-text-fill-color: #fff;
  transition: background-color 50000s ease-in-out 0s;
}
@-webkit-keyframes wobble-vertical {
  0% {
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
  }
  25% {
    -webkit-transform: translateY(8px);
    transform: translateY(8px);
  }
  50% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
  }
  75% {
    -webkit-transform: translateY(8px);
    transform: translateY(8px);
  }
  100% {
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
  }
}

@keyframes wobble-vertical {
  0% {
    -webkit-transform: translateY(0px);
    -ms-transform: translateY(0px);
    transform: translateY(0px);
  }
  25% {
    -webkit-transform: translateY(8px);
    -ms-transform: translateY(8px);
    transform: translateY(8px);
  }
  50% {
    -webkit-transform: translateY(-8px);
    -ms-transform: translateY(-8px);
    transform: translateY(-8px);
  }
  75% {
    -webkit-transform: translateY(8px);
    -ms-transform: translateY(8px);
    transform: translateY(8px);
  }
  100% {
    -webkit-transform: translateY(0px);
    -ms-transform: translateY(0px);
    transform: translateY(0px);
  }
}
@keyframes loginmove {
  0% {
    opacity: 0;
    -webkit-transform: translateY(50px);
    -ms-transform: translateY(50px);
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    transform: translateY(0);
  }
}
</style>
